import Instance from "../../../../Axios";

// New Actions for the app

const GetObraWorkPermits = (idObra) => async (dispatch) => {
  await Instance()
    .get(`/construcoes/workpermits/workpermit/${idObra}`)
    .then(({ data }) => {
      // console.log(data);
      dispatch({ type: "GET_OBRA_WORK_PERMITS", payload: data.yData });
      // setObraSelecionada(data.yData[0]);
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetObraWorkPermits;